interface RegexMatcherMap {
  anyManifestPermission: string
}

export const regexMatchers: RegexMatcherMap = {
  anyManifestPermission: '^manifests[.].*'
}
